import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://raintreechinesemedicine.com.au'

const nameMap: Record<string, string> = {
  '/': 'Home',
  '/appointments': 'Appointments & Fees',
  '/about': 'About',
  '/blog': 'Blog',
  '/contact': 'Contact',
  '/privacy': 'Privacy Policy',
  '/what-we-help-with': 'What We Help With',
  '/what-we-help-with/fertility-preconception': 'Preconception Care & Fertility Support',
  '/what-we-help-with/pregnancy-postpartum': 'Pregnancy & Postpartum Support',
  '/what-we-help-with/menstrual-hormonal-health': 'Menstrual & Hormonal Health',
  '/what-we-help-with/stress-sleep-digestion': 'Stress, Sleep & Digestive Balance',
  '/what-we-help-with/womens-health-long-term-care': 'Ongoing Women\'s Health & Long-Term Care',
  '/what-we-help-with/other-concerns': 'Other Concerns',
  '/continue-care': 'Continue Your Care',
  '/conditions': 'Conditions',
  '/conditions/endometriosis': 'Endometriosis',
  '/conditions/fertility': 'Fertility',
  '/conditions/pregnancy': 'Pregnancy',
  '/conditions/menopause': 'Menopause',
  '/conditions/stress-anxiety': 'Stress & Anxiety',
  '/conditions/allergies': 'Allergies',
  '/conditions/asthma': 'Asthma',
  '/conditions/insomnia': 'Insomnia',
  '/conditions/headaches-migraines': 'Headaches & Migraines',
  '/conditions/chronic-fatigue': 'Chronic Fatigue',
  '/conditions/high-blood-pressure': 'High Blood Pressure',
  '/conditions/menstrual-cramps': 'Menstrual Cramps',
  '/conditions/endometriosis-holistic': 'Endometriosis (Holistic)',
  '/conditions/pcos': 'PCOS',
  '/conditions/fertility-support': 'Fertility Support',
  '/conditions/pregnancy-support': 'Pregnancy Support',
  '/conditions/postpartum': 'Postpartum',
  '/conditions/menopause-symptoms': 'Menopause Symptoms',
  '/conditions/stress-anxiety-relief': 'Stress & Anxiety',
  '/conditions/depression': 'Depression',
  '/conditions/digestive-health': 'Digestive Health',
  '/conditions/immune-support': 'Immune Support',
  '/conditions/arthritis-joint-pain': 'Arthritis & Joint Pain',
  '/conditions/sports-injuries': 'Sports Injuries',
  '/conditions/sciatica': 'Sciatica',
  '/conditions/carpal-tunnel': 'Carpal Tunnel',
  '/conditions/bells-palsy': 'Bell’s Palsy',
  '/conditions/tmj': 'TMJ & Jaw Pain',
  '/conditions/sinusitis': 'Sinusitis',
  '/conditions/smoking-cessation': 'Smoking Cessation',
}

export function BreadcrumbsJsonLd() {
  const { pathname } = useLocation()

  const items = [] as Array<{ '@type': 'ListItem'; position: number; name: string; item: string }>
  // Home always first
  items.push({ '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL })

  if (pathname.startsWith('/conditions/') && pathname !== '/conditions') {
    // Add hub breadcrumb then the condition page
    items.push({ '@type': 'ListItem', position: 2, name: nameMap['/conditions'], item: new URL('/conditions', SITE_URL).toString() })
    if (nameMap[pathname]) {
      items.push({ '@type': 'ListItem', position: 3, name: nameMap[pathname], item: new URL(pathname, SITE_URL).toString() })
    }
  } else if (pathname.startsWith('/what-we-help-with/') && pathname !== '/what-we-help-with') {
    // Add hub breadcrumb then the child page
    items.push({ '@type': 'ListItem', position: 2, name: nameMap['/what-we-help-with'], item: new URL('/what-we-help-with', SITE_URL).toString() })
    if (nameMap[pathname]) {
      items.push({ '@type': 'ListItem', position: 3, name: nameMap[pathname], item: new URL(pathname, SITE_URL).toString() })
    }
  } else if (pathname !== '/' && nameMap[pathname]) {
    items.push({ '@type': 'ListItem', position: 2, name: nameMap[pathname], item: new URL(pathname, SITE_URL).toString() })
  }

  if (items.length < 2) return null

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}


